// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__14Aba","container":"styles_container__1wD2r","title":"styles_title__2gJnG","wrapper":"styles_wrapper__1MzFd","answer":"styles_answer__1_Gmk"};